export default __webpack_public_path__ + "static/media/img9.a3619e1f.png";